export enum AccountType {
    ODP = 'ODP',
    HUB = 'Hub'
}

export enum AppFeature {
  DESTINATION_APP = 'DESTINATION_APP',
  SOURCE_APP = 'SOURCE_APP',
  OPAL_TOOL_APP = 'OPAL_TOOL_APP',
  CMS_UI_EXTENSION_APP = 'CMS_UI_EXTENSION_APP',
}

export enum AppWorksWith {
  CMS = 'CMS',
  OPAL = 'Opal'
}

export const OPAL_CATEGORY = 'Opal';
